import ReactTooltip from 'react-tooltip';

const TableColumnTooltip = () => (
  <ReactTooltip data-place="top" id="table" backgroundColor="white" textColor="black" arrowColor="transparent" />
);

export default TableColumnTooltip;
